import gql from 'graphql-tag';

export const CreateContentMentionNotificationAction = gql`
	mutation CreateContentMentionNotificationAction($contentId: ID!, $mentions: [ContentMention]!) {
		createContentMentionNotificationAction(input: { contentId: $contentId, mentions: $mentions }) {
			contentId
			success
			errors {
				message
			}
		}
	}
`;
